<template>
  <div class="modal coming-soon-modal">
    <div class="overlay" @click="close"></div>

    <div class="wrapper">
      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <img
              class="close"
              src="./../img/close.svg"
              alt="Close"
              @click="close"
            />

            <div class="form-fields">
              <div class="form-fields-wrapper">
                <div class="soon-icon">
                  <svg
                    width="52"
                    height="52"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                  >
                    <circle
                      cx="24"
                      cy="24"
                      r="18"
                      stroke="currentColor"
                      stroke-width="2.5"
                    />
                    <path
                      d="M24 13V24L31 29"
                      stroke="currentColor"
                      stroke-width="2.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>

                <div class="title dark soon-title">COMING SOON</div>

                <div class="desc dark soon-description">
                  Selling skins is not available yet.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComingSoonModal',

  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>

<style scoped lang="scss">
.coming-soon-modal {
  z-index: 99999;

  .wrapper {
    max-width: 480px;
  }

  .container {
    padding: 42px 26px;
  }

  .close {
    cursor: pointer;
  }

  .form-fields-wrapper {
    max-width: 400px;
    margin: 0 auto;
    padding: 10px 0 20px;
    text-align: center;
  }

  .soon-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 94px;
    height: 94px;
    margin: 0 auto 28px;
    border: 1px solid rgba(255, 255, 255, 0.16);
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.08);
    color: #0d4e9e;
  }

  .soon-title {
    margin-bottom: 16px;
    text-align: center;
  }

  .soon-description {
    max-width: 300px;
    margin: 0 auto;
    text-align: center;
    line-height: 1.7;
    opacity: 0.75;
  }
}

@media screen and (max-width: 768px) {
  .coming-soon-modal {
    .wrapper {
      max-width: 100%;
    }

    .container {
      padding: 32px 20px;
    }

    .soon-icon {
      width: 80px;
      height: 80px;
      margin-bottom: 22px;
    }
  }
}
</style>
